// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"c741ed31","68":"4a5c3825","80":"cc4d6fef","121":"cc4d6fef","340":"78d477de"}[chunkId] + ".chunk.css";
};